/**
 * Runs async tasks one at a time per key. A task starts only once the one queued before
 * it under the same key has settled, whether that one succeeded or failed; tasks under
 * different keys do not wait for each other. Each call returns its own task's result.
 */
export function serializeByKey() {
  const tails = new Map<string, Promise<unknown>>();

  return function run<T>(key: string, task: () => Promise<T>): Promise<T> {
    const result = (tails.get(key) ?? Promise.resolve()).then(() => task());
    const tail = result.catch(() => undefined);
    tails.set(key, tail);
    // Forget the key once its queue drains, so ids do not pile up over a long session.
    void tail.then(() => { if (tails.get(key) === tail) tails.delete(key); });
    return result;
  };
}
